import { createContext, useContext, useState, useCallback } from 'react';

const DemoContext = createContext(null);

export function DemoProvider({ children }) {
  const [demoActive, setDemoActive] = useState(false);

  const startDemo = useCallback(() => setDemoActive(true), []);
  const stopDemo = useCallback(() => setDemoActive(false), []);

  return (
    <DemoContext.Provider value={{ demoActive, startDemo, stopDemo }}>
      {children}
    </DemoContext.Provider>
  );
}

export function useDemo() {
  const ctx = useContext(DemoContext);
  if (!ctx) throw new Error('useDemo must be inside DemoProvider');
  return ctx;
}
